import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'errorMinValue',
})
export class ErrorMinValuePipe implements PipeTransform {
  constructor(private TRANSLATE: TranslateService) {}

  /**
   * returns the error message about the minimum value for the input.
   * @author Martin Batun Tec.
   */
  transform({
    actualLength,
    requiredLength,
  }: {
    actualLength: number;
    requiredLength: number;
  }): string {
    let msg = this.TRANSLATE.instant('shared:minLengthIs');
    msg = msg.replace('[n]', requiredLength - actualLength);
    msg = msg.replace('[e]', requiredLength);
    return msg;
  }
}
